<!--Instructions-->
<div>
	<h4 class="InstructionText">The following schools do not have enough Digital ID activations left to activate all of the users you are trying to email.</h4>
	<h4 class="InstructionText">You can still send the emails but not all users will be able to activate the app until more activations are added.</h4>
	<h4 class="InstructionText">
		Please
		<a href="https://www.access411.com/online-support/">Contact Support</a>
		to get more activations.
	</h4>
</div>

<!--Table-->
<div class="MainTable">
	<p-table
		#mydt
		[value]="lstSchool"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedSchool"
		dataKey="SchoolID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--SchoolNumber-->
				<th>
					<p-columnFilter type="text" field="SchoolNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolName-->
				<th>
					<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--MissingEntries-->
				<th>
					<p-columnFilter type="text" field="MissingEntries" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="SchoolNumber">School Number<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School Name<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="MissingEntries"># of Missing Activations<p-sortIcon field="MissingEntries"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-School>
			<tr [pSelectableRow]="School">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ School[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onSendAnyways()">Send Anyways</button>
	<button class="btn btn-warning LeftMargin" (click)="onClose()">Cancel</button>
</div>
